export default __webpack_public_path__ + "static/media/serasa-tela.eb9244da.png";